import React, { useState } from 'react';
import EyeClosed from 'components/SvgIcons/EyeClosed';
import EyeOpen from 'components/SvgIcons/EyeOpen';

import styles from './PasswordToggle.module.scss';

interface PasswordToggleProps {
  onToggle: (type: React.HTMLInputTypeAttribute) => void;
}

const PasswordToggle: React.FC<PasswordToggleProps> = ({ onToggle }) => {
  const [passwordVisibility, setPasswordVisibility] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisibility(!passwordVisibility);
    onToggle(passwordVisibility ? 'password' : 'text');
  };

  return (
    <button id="btn-password-toggle" type="button" onClick={togglePasswordVisibility} className={styles.container}>
      {passwordVisibility ? <EyeOpen /> : <EyeClosed />}
    </button>
  );
};

export default PasswordToggle;
